
































import { Component, Prop } from "vue-property-decorator";
import AppVue from "@/AppVue.vue";
import { WorkshopService } from "@/core/services";
import { ImportingResultModel } from "@/core/models";
import { InputUploadCpt } from "@/core/components";

@Component({
  components: {
    InputUploadCpt,
  },
})
export default class WorkshopsImportingView extends AppVue {
  loading = false;
  message = "";
  messageType = "";

  get exampleFile() {
    return require("@/styles/files/Participant_list_example.xlsx");
  }

  importing(file: any) {
    this.messageType = "";
    this.message = "";
    this.loading = true;
    try {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        try {
          const resp: ImportingResultModel = await WorkshopService.importWorkshop(e.target.result);
          this.parseImportingResponse(resp);
        } catch (error) {
          this.setMessage("warning", "Sorry! Something went wrong while reading the file");
        } finally {
          this.clearFiles();
          this.loading = false;
        }
      };
      reader.readAsDataURL(file.file);
    } catch (error) {
      this.clearFiles();
      this.loading = false;
      this.setMessage("warning", "Sorry! Something went wrong while reading the file");
    }
  }

  parseImportingResponse(data: ImportingResultModel) {
    if (data.isSuccess) {
      this.setMessage("success", "Workshop successfully imported");
    } else {
      this.setMessage("warning", data.message);
    }
  }

  setMessage(messageType: string, message: string) {
    this.messageType = messageType;
    this.message = message;
  }

  clearFiles() {
    const uploadRef: any = this.$refs.inputUpload;
    uploadRef.clearFiles();
  }
}
